import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as settingActions from "../../actions/settingActions";
import * as homePageActions from "../../actions/homePageActions";
import { Container, Row, Col, Form, FormControl } from "react-bootstrap";
import Iframe from "react-iframe";
import { useForm } from "react-hook-form";
import Button from "../../Component/Button";
import Slider from "react-slick";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import DOMPurify from "dompurify";
import "react-quill/dist/quill.snow.css";
import Loading from "../../Component/Loader/DataLoader";
import "./Programs.css";
import { useLocation } from "react-router-dom";


const Index = (props) => {
  const { actions, brand, setting, title } = props;
  const { register, errors, handleSubmit } = useForm();
  const [pageLoadData, setPageLoadData] = useState("");
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const type = params.get("is_mobile")
  // const [editorHtml, setEditorHtml] = useState("");

  useEffect(() => {
    const fetchData = () => {
      actions.getSettingData();
      actions.getBrandData();
      window.scrollTo(0, 0);
      document.title = "vLookUp - Programs";
      document
        .querySelector('meta[name="description"]')
        .setAttribute(
          "content",
          "Would like to be a mentor or mentee with us? Queries? Concerns?  Get in touch with us and we will be happy to assist you with your inquiries."
        );
    };
    fetchData();
  }, [actions, title]);

  const onSubmit = (data) => {
    actions.sendContactUs(data);
  };

  const patner_slider = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  var patner_slider2 = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: false,
    autoplay: true,
    slidesToShow: 5,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const unescapeHtml = (escapedHtml) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(escapedHtml, "text/html");
    return doc.body.textContent || "";
  };

  const handlePageLoadData = async () => {
    setLoader(true);
    try {
      const response = await agent.get(API.PROGRAMS);
      //   let rawHtml = response?.data?.data?.description || "";

      // Unescape the encoded HTML
      //   let unescapedHtml = unescapeHtml(rawHtml);

      // Replace &nbsp; (non-breaking space) with regular spaces
      //   unescapedHtml = unescapedHtml.replace(/\u00a0/g, " ");

      // Sanitize the HTML
      //   const cleanHtml = DOMPurify.sanitize(unescapedHtml);

      //   console.log("Clean", cleanHtml);

      // Set for rendering
      setPageLoadData(response?.data?.data?.description || "");
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log("Error ", error.message);
    }
  };

  if (type) {
    const els = document.querySelectorAll(".growWithUsPage");

    if (els.length > 0) {
      els.forEach(el => {
        el.style.paddingTop = "0";
      });
    }

  }


  useEffect(() => {
    handlePageLoadData();
  }, []);

  return (
    <>
      {loader && <Loading />}
      
      <div dangerouslySetInnerHTML={{ __html: pageLoadData }} />

      <section className="brand_sec partner_brand">
        <Container>
          <div className="title text-center space-bottom secondaryTitle pb-3 pb-md-5 pr-0">
            Partnering Organisations and Institutions
          </div>

          <Slider {...patner_slider2}>
            {brand &&
              brand.length &&
              brand.map((item, key) => (
                <div key={key}>
                  <div className="brand">
                    <img
                      src={item.image}
                      alt="professional consultants for women"
                    />
                  </div>
                </div>
              ))}
          </Slider>


        </Container>
      </section>

      <section className="parter-slider py-4">
        <Container>
          <h2 className="title text-center space-bottom position-relative">
            Gallery
          </h2>
          <Slider {...patner_slider}>


            {/* new */}

            <div className="client_slider">
              <div className="client_slider_inner">
                <div className="partner-img">
                  <img
                    src="../assets/images/testimonial/Modec.jpeg"
                    alt=""
                    className="w-100"
                  />
                </div>

                <div className="slider-content">
                  <h3>
                    <b>
                      Event: MODEC HERIZON Women Leadership Development Program{" "}
                    </b>
                  </h3>
                </div>
              </div>
            </div>

            <div className="client_slider">
              <div className="client_slider_inner">
                <div className="partner-img">
                  <img
                    src="../assets/images/testimonial/Ignite.jpg"
                    alt=""
                    className="w-100"
                  />
                </div>

                <div className="slider-content">
                  <h3>
                    <b>
                      Event: IGNITE Professional Women Network and Mentoring Program{" "}
                    </b>
                  </h3>
                </div>
              </div>
            </div>

            <div className="client_slider">
              <div className="client_slider_inner">
                <div className="partner-img">
                  <img
                    src="../assets/images/testimonial/Masoom.jpg"
                    alt=""
                    className="w-100"
                  />
                </div>

                <div className="slider-content">
                  <h3>
                    <b>
                      Event: Olay STEM Mentoring Programme 3.0{" "}
                    </b>
                  </h3>
                </div>
              </div>
            </div>

            <div className="client_slider">
              <div className="client_slider_inner">
                <div className="partner-img">
                  <img
                    src="../assets/images/testimonial/olay.png"
                    alt=""
                    className="w-100"
                  />
                </div>

                <div className="slider-content">
                  <h3>
                    <b>Event: Olay STEM Mentoring Programme 2.0</b>
                  </h3>
                </div>
              </div>
            </div>

            <div className="client_slider">
              <div className="client_slider_inner">
                <div className="partner-img">
                  <img
                    src="../assets/images/testimonial/republic.jpg"
                    alt=""
                    className="w-100"
                  />
                </div>

                <div className="slider-content">
                  <h3>
                    <b>Event: Republic Polytechnic x vLookUp</b>
                  </h3>
                </div>
              </div>
            </div>

            <div className="client_slider">
              <div className="client_slider_inner">
                <div className="partner-img">
                  <img
                    src="../assets/images/testimonial/dell.jpg"
                    alt=""
                    className="w-100"
                  />
                </div>

                <div className="slider-content">
                  <h3>
                    <b>
                      Event: Dell, Women in Action, Girls in Tech Mentoring
                      Programme
                    </b>
                  </h3>
                </div>
              </div>
            </div>

            <div className="client_slider">
              <div className="client_slider_inner">
                <div className="partner-img">
                  <img
                    src="../assets/images/testimonial/gitpic.png"
                    alt=""
                    className="w-100"
                  />
                </div>

                <div className="slider-content">
                  <h3>
                    <b>
                      Event: GIT x NCS x vLookUp Hackathon Empowering{" "}
                    </b>
                  </h3>
                </div>
              </div>
            </div>

            <div className="client_slider">
              <div className="client_slider_inner">
                <div className="partner-img">
                  <img
                    src="../assets/images/testimonial/SCSWIT.jpeg"
                    alt=""
                    className="w-100"
                  />
                </div>

                <div className="slider-content">
                  <h3>
                    <b>
                      Event: WITCircle Women Mentoring Programme{" "}
                    </b>
                  </h3>
                </div>
              </div>
            </div>



          </Slider>
        </Container>
      </section>
    </>
  );
};

function mapStateToProps(state) {
  return {
    setting: state.setting,
    brand: state.brand,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      Object.assign(settingActions, homePageActions),
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
